// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__cUT1v","back-button-span":"BackButton_back-button-span__BLqSd","back-button-icon":"BackButton_back-button-icon__O63Fk"};